import Globalize from 'globalize';

export default class GlobalizeWrapper {
    static defaults = async (culture) => {

        var lang = 'de';

        if (culture.toLowerCase() === 'de-de') {
            lang = 'de';
        } else if (culture.toLowerCase() === 'fr-fr') {
            lang = 'fr';
        } else if (culture.toLowerCase() === 'it-it') {
            lang = 'it';
        } else if (culture.toLowerCase() === 'da-dk') {
            lang = 'da';
        }

        await Globalize.load(
            require('cldr-data/supplemental/likelySubtags.json'),
            require('cldr-data/supplemental/timeData.json'),
            require(`cldr-data/main/${lang}/ca-gregorian.json`),
            require(`cldr-data/main/${lang}/numbers.json`),
        );

        window.Globalize = Globalize(culture);
    }
}